import React, { useState, useEffect } from "react";
import { data, useOutletContext } from "react-router-dom";
import { getSaham, postSaham } from "../api/services/sahamApi";


function AddSaham() {

    useEffect(() => {
        document.title = 'Tambah Saham | Sembako'
        getSaham().then(res => setDataSaham(res.data.data))
        
    },[])
    
    const {title, setTitle} = useOutletContext();
    setTitle('Tambah Saham');
    
    const [dataSaham, setDataSaham] = useState([]);
    const [nama, setNama] = useState('');
    const [nomer, setNomer] = useState('');
    const [jmlSaham, setJmlSaham] = useState('');
    const [isSubmiting, setIsSubmiting] = useState(false);

    const handleSubmit = async(event) => {
        setIsSubmiting(true);
        event.preventDefault();
        try {
            const newPost = await postSaham({nama, nomer, jmlSaham});
            alert('Saham berhasil dibuat');
            getSaham().then(res => setDataSaham(res.data.data))
            setNama('');
            setNomer('');
            setJmlSaham('');
            setIsSubmiting(false);
        } catch (error) {
            alert('Gagal menambahkan saham')
            setIsSubmiting(false);
            console.log(error);
        }
    }


    return(
        <>
            <form onSubmit={handleSubmit}>
                <div className="mt-10">
                    <label>Nama Saham</label>
                    <input type="text" className="block w-full mt-3 p-3 border-solid border-gray-200 border-3 rounded-2xl" value={nama} onChange={(e) => setNama(e.target.value)} />
                </div>
                <div className="mt-10">
                    <label>Nomer Saham</label>
                    <select type="text" className="block w-full mt-3 p-3 border-solid border-gray-200 border-3 rounded-2xl" value={nomer} onChange={(e) => setNomer(e.target.value)}>
                        <option key="0" selected>Pilih nomer saham</option>
                        {
                            dataSaham.map((val, i) => 
                                val.nama == '' ? (
                                    <option key={i} value={val.nomer}>{val.nomer}</option>
                                ) : (<></>)
                            )
                        }
                    </select>
                </div>
                <div className="mt-10">
                    <label>Jumlah Saham</label>
                    <input type="text" className="block w-full mt-3 p-3 border-solid border-gray-200 border-3 rounded-2xl" value={jmlSaham} onChange={(e) => setJmlSaham(e.target.value)}/>
                </div>
                <div className="mt-10">
                    <button type="submit" className="p-6 w-full align-center flex justify-center rounded-2xl 
                    text-white font-semibold bg-[#8570FF]" disabled={isSubmiting}>
                        <svg className="inline-block mr-3 icon icon-tabler icons-tabler-outline icon-tabler-plus" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" 
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                            ><path stroke="none" d="M0 0h24v24H0z" 
                            fill="none"/><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
                        {isSubmiting ? 'MENAMBAHKAN ...' : 'TAMBAHKAN' }
                    </button>
                </div>
            </form>
        </>
    );
}

export default AddSaham;